import { render } from "./seating_chart_sort_by.vue?vue&type=template&id=11938440"
import script from "./seating_chart_sort_by.vue?vue&type=script&lang=js"
export * from "./seating_chart_sort_by.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__